<template>
    <div id="about-usRes">
        <div class="container mb-5">
            <div class="row  justify-content-center">
                <div class="col-sm-8 col-12  div__title">
                    <h3>Quiénes somos</h3>
                </div>
            </div>
            <div class="row  justify-content-center">
                <div class="col-sm-8 col-12 my-3">
                    <small>{{ whoweare }}</small>
                </div>
                <div class="col-sm-8 col-12 my-3 div__title">
                    <h3>Misión</h3>
                </div>
                <div class="col-sm-8 col-12">
                    <small>{{ mission }}</small>
                </div>
                <div class="col-sm-8 col-12 my-3 div__title">
                    <h3>Visión</h3>
                </div>
                <div class="col-sm-8 col-12">
                    <small>{{ vision }}</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "aboutus_resp",
    // data() {
    //     return {
    //         manageables: undefined,
    //     };
    // },
props: {
    whoweare: {
      type: String,
      request: true,
    },
    mission: {
      type: String,
      request: true,
    },
    vision: {
      type: String,
      request: true,
    },
  }
};
</script>

<style lang="scss" scoped>
$primaryColor: #0153a2;

.div__title {
    border-bottom-style: solid;
    border-bottom-color: $primaryColor;
}

img {
    width: 30px;
}
</style>